define('webshopLandingpagesDetailView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'windows',
  'headerFooterView',
  'webshopLandingpagesDetailHeaderView',
  'webshopLandingpagesDetailBodyView',
  'entities/webshop/landingpages'
], function (
  App,
  Module,
  Backbone,
  _,
  Windows,
  HeaderFooterView,
  HeaderView,
  BodyView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'webshop-landingpages-detail-view ' + HeaderFooterView.prototype.className,
    childHeaderView: HeaderView,
    childView: BodyView,

    modelEvents: {
      'change:texts': function () {
        this.windowView.setTitle();
      }
    },

    initialize: function () {
      HeaderFooterView.prototype.initialize.call(this);

      this.view.on('selected', _.bind(function () {  
        Windows.setNavigation();
      }, this));      
    },    

    // Static methods
    open: function (id, tabName) {
      require([
        'windows',
        'webshopLandingpagesDetailView'
      ], function (Windows, View) {     
        Windows.open({             
          view: _.bind(function () {
            var defer = $.Deferred(); 
            var model = App.request('webshop.landingpage.model', {id: id});
            App.request('webshop.config').done(_.bind(function (webshopConfig) {
              model.fetch().done(_.bind(function () {
                defer.resolve(new View({
                  model: model,
                  webshopConfig: webshopConfig,
                  tabName: tabName
                }));
              }, this));
            }, this));
            return defer.promise();
          }, this),          
          navigation: _.bind(function (windowView, view) {
            var defer = $.Deferred(); 
            if(view) {
              var uri = 'webshop/landingpages/' + view.model.get('id');
              var tab = view.view.getSelected();
              if (tab && tab.get('url') !== '')
                uri += '/' + tab.get('url');
              defer.resolve(uri);
            }
            return defer.promise();
          }, this),         
          title: _.bind(function (windowView, view) {            
            return _.i18n('webshop.landingpage.title') + ' | ' + view.model.getCode();
          }, this),
          id: 'webshop.landingpage:' + id,
          width: '80%',
          height: '80%'
        });
      });
    }
  });
});

